import type { CreateCarouselBannerValidationSchema } from "src/features/HomepageCarouselBanners/components/CreateCarouselBannerForm/CreateCarouselBannerForm";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CreateCarouselBannerForm } from "src/features/HomepageCarouselBanners/components/CreateCarouselBannerForm";
import { useCarouselBanner } from "src/features/HomepageCarouselBanners/hooks/useCarouselBanner";
import { useEditCarouselBanner } from "src/features/HomepageCarouselBanners/hooks/useEditCarouselBanner";
import normalizeUrl from "src/features/HomepageCarouselBanners/utils/normalizeUrl";

export interface EditCarouselBannerProps {}

const EditCarouselBanner = () => {
	const { formId: bannerId } = useParams<{ formId: number }>();

	const [defaultValues, setDefaultValues] =
		useState<Partial<CreateCarouselBannerValidationSchema>>();

	const { data: banner } = useCarouselBanner(bannerId);
	const { mutate: editForm } = useEditCarouselBanner();

	const onValid = (data: any) => {
		editForm({
			id: bannerId,
			...data,
			webLink: data.webLink ? normalizeUrl(data.webLink) : data.webLink
		});
	};

	useEffect(() => {
		if (!banner) return;

		if (banner.template === "fullImageBanner") {
			setDefaultValues({
				id: banner.id,
				template: banner.template,
				bannerType: banner.bannerType,
				imageUuid: banner.imageUuid,
				headingText: banner.headingText,
				subheadingText: banner.subheadingText,
				name: banner.name,
				linkType: banner.linkType,
				webLink: banner.webLink,
				openInBrowser: banner.openInBrowser,
				feed: banner.feed?.uuid,
				selectedFeed: banner.feed ?? undefined,
				audienceGroupIds: (banner.audienceGroups ?? []).map((g) => g.id)
			});
		}

		if (banner.template === "videoBanner") {
			setDefaultValues({
				id: banner.id,
				template: banner.template,
				bannerType: banner.bannerType,
				videoUuid: banner.videoUuid,
				headingText: banner.headingText,
				subheadingText: banner.subheadingText,
				name: banner.name,
				audienceGroupIds: (banner.audienceGroups ?? []).map((g) => g.id)
			});
		}

		if (banner.template === "textBanner") {
			setDefaultValues({
				id: banner.id,
				template: banner.template,
				bannerType: banner.bannerType,
				backgroundColor: banner.backgroundColor,
				foregroundColor: banner.foregroundColor,
				headingText: banner.headingText,
				subheadingText: banner.subheadingText,
				name: banner.name,
				linkType: banner.linkType,
				webLink: banner.webLink,
				openInBrowser: banner.openInBrowser,
				feed: banner.feed?.uuid,
				selectedFeed: banner.feed ?? undefined,
				audienceGroupIds: (banner.audienceGroups ?? []).map((g) => g.id)
			});
		}
	}, [banner]);

	return (
		<CreateCarouselBannerForm onValid={onValid} defaultValues={defaultValues} />
	);
};

export default EditCarouselBanner;
